import clsx from 'clsx';
import React, { useEffect, useMemo } from 'react';
import styles from './AdBox.module.scss';
import { T } from '@colonist/ui';
import { AD_BOX_CONTENT } from '../../constants.ts';
import { useGameStore } from '../../../../store/GameStoreContext.ts';
export const AdBox = ({ className })=>{
    const shouldShowEndGameAd = useGameStore((state)=>state.gameClientConfig.shouldShowEndGameAd);
    const shouldExcludeStoreAdContent = useGameStore((state)=>state.gameClientConfig.shouldExcludeStoreAdContent);
    const onClickGameEndAd = useGameStore((state)=>state.gameClientConfig.onClickGameEndAd);
    const adBoxContent = useMemo(()=>{
        const allContent = AD_BOX_CONTENT;
        if (shouldExcludeStoreAdContent) {
            const contentWithoutMemberGifAds = allContent.filter((content)=>content.adSource != 'endGameMemberGif');
            return contentWithoutMemberGifAds;
        }
        return allContent;
    }, [
        shouldExcludeStoreAdContent
    ]);
    const sendEndgameAdBoxClickAnalytics = useGameStore((state)=>state.gameAnalytics.sendEndgameAdBoxClickAnalytics);
    const sendRushAdImpressionAnalytics = useGameStore((state)=>state.gameAnalytics.sendRushAdImpressionAnalytics);
    const sendRushAdClickAnalytics = useGameStore((state)=>state.gameAnalytics.sendRushAdClickAnalytics);
    const randomIndex = useMemo(()=>Math.floor(Math.random() * adBoxContent.length), [
        adBoxContent
    ]);
    const selectedContent = adBoxContent[randomIndex];
    useEffect(()=>{
        if (shouldShowEndGameAd == false) return;
        sendRushAdImpressionAnalytics(selectedContent.adSource, selectedContent.variant);
    }, [
        shouldShowEndGameAd,
        selectedContent,
        sendRushAdImpressionAnalytics
    ]);
    const onClickAdBox = ()=>{
        sendEndgameAdBoxClickAnalytics();
        sendRushAdClickAnalytics(selectedContent.adSource, selectedContent.variant);
        onClickGameEndAd(selectedContent.adSource == 'endGame');
    };
    if (shouldShowEndGameAd == false) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.imageContainer
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.image,
        onClick: onClickAdBox,
        src: adBoxContent[randomIndex].image
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.text
    }, /*#__PURE__*/ React.createElement(T, {
        id: adBoxContent[randomIndex].title
    })));
};
